import React from 'react'

import { Box, Typography } from '@mui/material'
import { Send } from 'lucide-react'

import Avatar from '../../../../shared/components/Avatar/Avatar.component'

import { getFirstAndLastName } from '../RecipientCard/recipientCard.functions'
import styles from './SenderCard.styles'
import type { SenderCardProps } from './SenderCard.types'

const SenderCard: React.FC<SenderCardProps> = ({ sender }) => {
  const { firstName, lastName } = getFirstAndLastName(sender.name)

  return (
    <Box sx={styles.card}>
      <Box sx={styles.cardHeader}>
        <Typography sx={styles.cardTitle}>Sent By</Typography>
        <Box sx={styles.iconWrap}>
          <Send size={15} color="#F59E0B" />
        </Box>
      </Box>

      <Box sx={styles.avatarRow}>
        <Avatar firstName={firstName} lastName={lastName} size="medium" noRightMargin gradient />
        <Typography sx={styles.senderName}>{sender.name}</Typography>
      </Box>
    </Box>
  )
}

export default SenderCard
